module.exports = __webpack_public_path__ + "img/waves-white.7b157e7c.svg";